export default {
  valueItemisation: 'value-itemisation',
  valueItemisationSkeleton: 'value-itemisation-skeleton',
};
